/* Experience switcher.

   Handles:
   - Experience tabs
   - Store selection
   - Google Maps embed switching
   - Static map image fallback
   - Directions link switching
   - Shopify Theme Editor section reloads
*/

(() => {

  function initSwitcher(root) {
    if (!root) return;

    if (root.dataset.experienceReady === "true") {
      return;
    }

    root.dataset.experienceReady = "true";


    /*
     * ========================================================
     * EXPERIENCE TABS
     * ========================================================
     */

    const tabs = [...root.querySelectorAll("[data-experience-tab]")];
    const panels = [...root.querySelectorAll("[data-experience-panel]")];
    const visual = root.querySelector("[data-experience-visual]");

    if (visual) {
      visual.dataset.visualVariant = "store";
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const selection = tab.dataset.experienceTab;

        tabs.forEach((candidate) => {
          const isSelected = candidate === tab;

          candidate.classList.toggle("is-active", isSelected);
          candidate.setAttribute(
            "aria-selected",
            String(isSelected)
          );
        });

        panels.forEach((panel) => {
          panel.classList.toggle(
            "is-active",
            panel.dataset.experiencePanel === selection
          );
        });

        if (!visual) return;

        visual.dataset.visualVariant = selection;

        const image = visual.querySelector("img");
        const caption = visual.querySelector("p");

        if (image && tab.dataset.visualSrc) {
          image.src = tab.dataset.visualSrc;
          image.alt = tab.dataset.visualAlt || "";
        }

        if (caption) {
          caption.innerHTML = tab.dataset.visualCopy || "";
        }
      });
    });


    /*
     * ========================================================
     * STORE SELECTOR
     * ========================================================
     */

    const storesContainer = root.querySelector(
      ".experience-panel__stores"
    );

    const mapImage = root.querySelector(
      "[data-store-map-image]"
    );

    const mapIframe = root.querySelector(
      "[data-store-map-iframe]"
    );

    const mapLink = root.querySelector(
      "[data-store-map-link]"
    );


    /*
     * If there is no store container, there is nothing
     * to initialise for the store map.
     */

    if (!storesContainer) {
      console.log(
        "[Carat & Kin] No store buttons found."
      );
      return;
    }


    /*
     * ========================================================
     * STORE BUTTON CLICK
     * ========================================================
     *
     * Event delegation is used here so that dynamically
     * rendered Shopify section content also works correctly.
     */

    storesContainer.addEventListener("click", (event) => {

      const button = event.target.closest(
        "button[data-store-map]"
      );

      if (!button) {
        return;
      }

      if (!storesContainer.contains(button)) {
        return;
      }

      event.preventDefault();


      /*
       * ------------------------------------------------------
       * Update active store
       * ------------------------------------------------------
       */

      const storeButtons = storesContainer.querySelectorAll(
        "button[data-store-map]"
      );

      storeButtons.forEach((storeButton) => {
        storeButton.classList.toggle(
          "is-active",
          storeButton === button
        );
      });


      /*
       * ------------------------------------------------------
       * Read selected store data
       * ------------------------------------------------------
       */

      const mapImageUrl =
        button.dataset.storeMap || "";

      const embedLink =
        button.dataset.storeEmbedLink || "";

      const storeLink =
        button.dataset.storeLink || "#";


      console.log(
        "[Carat & Kin] Store selected:",
        {
          name: button.querySelector("strong")?.textContent.trim(),
          mapImageUrl,
          embedLink,
          storeLink
        }
      );


      /*
       * ------------------------------------------------------
       * Google Maps embed
       * ------------------------------------------------------
       */

      if (embedLink && mapIframe) {

        mapIframe.src = embedLink;

        mapIframe.classList.add("is-active");

        if (mapImage) {
          mapImage.classList.remove("is-active");
        }

      }


      /*
       * ------------------------------------------------------
       * Static map fallback
       * ------------------------------------------------------
       */

      else if (mapImageUrl && mapImage) {

        mapImage.src = mapImageUrl;

        mapImage.classList.add("is-active");

        if (mapIframe) {
          mapIframe.classList.remove("is-active");
          mapIframe.removeAttribute("src");
        }

      }


      /*
       * ------------------------------------------------------
       * Neither map nor image available
       * ------------------------------------------------------
       */

      else {

        if (mapImage) {
          mapImage.classList.remove("is-active");
        }

        if (mapIframe) {
          mapIframe.classList.remove("is-active");
          mapIframe.removeAttribute("src");
        }

      }


      /*
       * ------------------------------------------------------
       * Update directions link
       * ------------------------------------------------------
       */

      if (mapLink) {
        mapLink.href = storeLink || "#";
      }

    });


    /*
     * ========================================================
     * DEBUG
     * ========================================================
     */

    console.log(
      "[Carat & Kin] Experience switcher initialized"
    );

    console.log(
      "[Carat & Kin] Store buttons:",
      storesContainer.querySelectorAll(
        "button[data-store-map]"
      ).length
    );

  }


  /*
   * ==========================================================
   * INITIAL PAGE LOAD
   * ==========================================================
   */

  document
    .querySelectorAll("[data-experience-switcher]")
    .forEach(initSwitcher);


  /*
   * ==========================================================
   * SHOPIFY THEME EDITOR
   * ==========================================================
   */

  document.addEventListener(
    "shopify:section:load",
    (event) => {

      event.target
        .querySelectorAll?.("[data-experience-switcher]")
        .forEach(initSwitcher);

    }
  );

})();